<template>
  <div>
    <!-- 上传附件 -->
    <el-upload
      class="avatar-uploader2"
      :action="action"
      :headers="gettoken()"
      :on-success="handleAvatarSuccess"
      :on-remove="handleAvatarRemove"
      :limit='1'
      accept=".mp4"
      :file-list="fileListHt"
      :before-upload="beforeAvatarUpload"
      :on-preview="previewAvatar"
      :disabled="disabled">
      <el-button size="mini" type="primary" :disabled="disabled">上传视频</el-button>
      <!-- <div slot="tip" class="el-upload__tip" style="color:#7a7a7a;position:absolute;left: 90px;top:4px;">可上传doc、docx、xls、xlsx、pdf文件</div> -->
      <!-- accept=".doc,.docx,.xls,.xlsx,.rar,.zip,.pdf,.jpg,.png" -->
    </el-upload>
    <el-dialog title="视频" :visible.sync="dialogTableVisible" :width="'1100px'">
      <video :src="srcmp4" width="auto" height="510px" controls type="video/mp4"></video>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/api/config'
export default {
  name: 'BoyoUploadThree',
  props: {
    action: String,
    src: String,
    value: String,
    fileListHt: Array,
    disabled: Boolean
  },
  data () {
    return {
      srcmp4:'',
      dialogTableVisible:false
    }
  },
  mounted () {

  },
  methods: {
    gettoken () {
      let Token = JSON.parse(localStorage.token).value
      let loginTissueId = localStorage.loginTissueId
      return { Token: Token,'X-Tissue-Id': loginTissueId}
    },
    myUpload (content) {
      axios({
        method: 'post',
        url: content.action,
        data: content.file
      }).then(res => {
        content.onSuccess(res.data)
      })
    },
    beforeAvatarUpload (file) {
      // console.log(file)
    },
    previewAvatar(file) { // 查看
      if(file.response && file.response.data && file.response.data.indexOf('.mp4') != -1){
        window.open(config.pingImgUrl + file.response.data)
      } else if(file.response && file.response.msg && file.response.msg.indexOf('.mp4') != -1){
        window.open(config.pingImgUrl + file.response.msg)
      } else if(file.url && file.url.indexOf('.mp4') != -1){
        window.open(config.pingImgUrl + file.url)
      }
      else if(file.response && file.response.data && file.response.data.indexOf('.mp4') != -1){
        // this.srcmp4 = config.pingImgUrl + file.response.data
        // this.dialogTableVisible = true
        this.$emit('on-dialog', file.response.data)
      }else if(file.response && file.response.msg && file.response.msg.indexOf('.mp4') != -1){
        // this.srcmp4 = config.pingImgUrl + file.response.msg
        // this.dialogTableVisible = true
        this.$emit('on-dialog', file.response.msg)
      } else if(file.url && file.url.indexOf('.mp4') != -1){
        // this.srcmp4 = config.pingImgUrl + file.url
        // this.dialogTableVisible = true
        this.$emit('on-dialog', file.url)
      }
    },
    handleAvatarSuccess (res, file, fileList) {
      this.$emit('on-success', res, file, fileList, this.value)
    },
    handleAvatarRemove (file, fileList) {
      this.$emit('on-remove', file, fileList, this.value)
    }
  }
}
</script>
<style lang="stylus" scoped>
.avatar-uploader>>> .el-upload
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
.avatar-uploader>>> .el-upload:hover
  border-color #409EFF
.avatar-uploader-icon
  font-size 28px
  color #8c939d
  width 85px
  height 85px
  line-height 85px
  text-align center
.avatar
  width 85px
  height 85px
  display block
.avatar-uploader2
  cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/BoyoUploadtwo/index.vue